import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from "react-router";
import { API_BASE_URL } from '../utils/apiConfig';

const Login = ({ onLoginSuccess }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    
    // Helper function to validate only the necessary fields
    const validateForm = () => {
        const newErrors = {};
        let isValid = true;

        if (!email) {
            newErrors.email = true;
            isValid = false;
        }
        if (!password) {
            newErrors.password = true;
            isValid = false;
        }
        
        setErrors(newErrors);
        return isValid;
    };
    
    // Function that runs when an input loses focus (for immediate highlighting)
    const handleBlur = (e) => {
        const { name, value } = e.target;
        if (!value) {
            setErrors(prev => ({ ...prev, [name]: true }));
        } else {
            setErrors(prev => ({ ...prev, [name]: false }));
        }
    };


    // handleSubmit function 
    async function handleSubmit(e) {
        e.preventDefault();
        setMessage("");

        // Run client-side validation first
        if (!validateForm()) {
            setMessage("Please enter both email and password.");
            return;
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/api/login`, { email, password });

            if (response.status >= 200 && response.status < 300) {
                // Trigger the buffer UI
                setIsLoggingIn(true);
                setMessage("Logging in...");
                setTimeout(() => {
                    onLoginSuccess(response.data.user, response.data.role); 

                    if (response.data.role === 'researcher') {
                        navigate("/research-portal");
                    } else {
                        navigate("/");
                    }
                }, 2000);
            }
        } catch (error) {
    
            if (error.response) {
                setMessage(error.response.data.message || "Invalid email or password.");
            } else {
                console.error("Frontend Logic Error:", error);
                setMessage("A technical error occurred. Check the console.");
            }
        }
    };

    // Login form
    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">
                    
                    {isLoggingIn ? (
                        <div className="login-buffer">
                            <h2 className="login-title">Logging in...</h2>
                            <p className="login-subtext">Preparing your session</p>
                            <div className="loader" style={{ margin: '20px auto' }}></div> 
                        </div>
                    ) : (
                        <>
                            <h2 className="login-title">Welcome Back</h2>
                            <p className="login-subtext">Log in to continue</p>

                            {message && <p className="login-message">{message}</p>}

                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>Email</label>
                                    <input 
                                        type="email" 
                                        name="email"
                                        value={email}
                                        onBlur={handleBlur} 
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="you@example.com" 
                                        required 
                                        className={errors.email ? 'input-error' : ''}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Password</label>
                                    <input 
                                        type="password" 
                                        name="password" 
                                        value={password}
                                        onBlur={handleBlur} 
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Enter your password" 
                                        required
                                        className={errors.password ? 'input-error' : ''}
                                    />
                                </div>

                                <button className="submit-btn" type="submit">
                                    Log In
                                </button>
                            </form>

                            <p className="signup-text">
                                Don’t have an account? 
                                <Link to="/signup" className="signup-link">Sign Up</Link>
                            </p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Login;